<script lang="ts" setup>
import { computed, ref } from 'vue';

import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useAlertStore } from '@/stores/alert';
import { AlertMode } from '@/types/components.js';

/***
 사용법:
 1. alertStore와 함께 사용
 2. alertStore.cancelAction === null 일 경우 확인버튼만 노출
 3. alertStore의 confirmAction, cancelAction, title, bodyTitle, message, bodyAccentTitle, subMessage 사용
 */

const alertStore = useAlertStore();
const processing = ref(false);

const mode = computed<AlertMode>(() => {
  return alertStore.alertMode;
});

const close = () => {
  alertStore.close();
};

const confirm = async () => {
  if (processing.value) {
    return;
  }
  processing.value = true;
  await alertStore.confirmAction();
  processing.value = false;
  close();
};

const cancel = async () => {
  await alertStore.cancelAction();
  close();
};

function closeByButton() {
  if (alertStore.clickSelfToClose) {
    close();
  }
}
</script>

<template>
  <ModalSmall
    v-if="alertStore.visible && mode === 'apec'"
    :title="alertStore.messages.title"
    :showCloseButton="alertStore.clickSelfToClose"
    @close="closeByButton"
  >
    <div>
      <h4 v-html="alertStore.messages.bodyTitle"></h4>
      <h4 class="semibold" v-html="alertStore.messages.bodyAccentTitle"></h4>
      <h4 v-html="alertStore.messages.message"></h4>
      <h4 v-html="alertStore.messages.subMessage"></h4>
    </div>
    <div class="modal-footer">
      <button
        class="button-secondary"
        v-if="alertStore.cancelAction !== null"
        @click="cancel"
      >
        {{ $t('cancel') }}
      </button>
      <ButtonProcess
        full-width
        :class="{
          'w-p100': alertStore.cancelAction === null,
        }"
        :loading="processing"
        @click="confirm"
        @keydown.enter="confirm"
      >
        <p class="medium">{{ alertStore.confirmButtonName }}</p>
      </ButtonProcess>
    </div>
  </ModalSmall>
</template>

<style lang="scss" scoped>
.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-footer {
  display: flex;
  margin-top: 1rem;
  gap: 0.5rem;
}

@media (min-width: 768px) {
  .modal-content {
    width: 25rem;
  }
}
</style>
